'use strict';
(function () {
  if (!customElements.get('pp-media-gallery')) {
    class PpMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.swiperMain = null;
        this.swiperThumbs = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        this.swiperMain?.destroy(true, false);
        this.swiperThumbs?.destroy(true, false);
      }
    }

    PpMediaGallery.prototype.initSwiper = function() {
      this.sliderMain = this.querySelector('[data-component="main-slider"]');
      this.sliderThumbs = this.querySelector('[data-component="thumbnails"]');

      if (!this.sliderMain || !this.sliderThumbs) return;

			const slides = this.sliderMain.querySelectorAll('.swiper-slide')

			const slidesPerViewMb =  slides?.length > 1 ? 1.35 : 1;

      this.swiperThumbs = new Swiper(this.sliderThumbs, {
        slidesPerView: 5.5,
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        loop: false,
				breakpoints: {
					769: {
						slidesPerView: 4,
						spaceBetween: 10,
					},
					1280: {
						slidesPerView: 4,
						spaceBetween: 16,
					},
				}
      });

      this.swiperMain = new Swiper(this.sliderMain, {
        slidesPerView: slidesPerViewMb,
        spaceBetween: 10,
        thumbs: {
          swiper: this.swiperThumbs, 
        },
        loop: true,
				breakpoints: {
					769: {
						slidesPerView: 1
					},
				}
      });
    };

    customElements.define('pp-media-gallery', PpMediaGallery);
  }
})();